var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNetworkLow = function SvgNetworkLow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 550 700"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#89898b",
    d: "M450 0a49.847 49.847 0 0 0-50 50v600a49.847 49.847 0 0 0 50 50h50a49.847 49.847 0 0 0 50-50V50a49.847 49.847 0 0 0-50-50Z",
    "data-name": "Path 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#89898b",
    d: "M250 150a49.847 49.847 0 0 0-50 50v450a49.847 49.847 0 0 0 50 50h50a49.847 49.847 0 0 0 50-50V200a49.847 49.847 0 0 0-50-50Z",
    "data-name": "Path 5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#bf2117",
    d: "M50 300a49.847 49.847 0 0 0-50 50v300a49.847 49.847 0 0 0 50 50h50a49.847 49.847 0 0 0 50-50V350a49.847 49.847 0 0 0-50-50Z",
    "data-name": "Path 6"
  })));
};
export default SvgNetworkLow;